import { render, staticRenderFns } from "./Timer.vue?vue&type=template&id=5a1bc1d5&scoped=true&"
import script from "./Timer.vue?vue&type=script&lang=ts&"
export * from "./Timer.vue?vue&type=script&lang=ts&"
import style0 from "./Timer.vue?vue&type=style&index=0&id=5a1bc1d5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1bc1d5",
  null
  
)

export default component.exports